import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { AircraftActions, AircraftActionTypes } from './aircraft.actions';
import { AircraftEntity } from './aircraft.model';

export interface AircraftEntities extends EntityState<AircraftEntity> {
  // additional entities state properties
}

export const adapter: EntityAdapter<AircraftEntity> = createEntityAdapter<AircraftEntity>();

export const initialState: AircraftEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): AircraftEntities {
  const action: AircraftActions = incomingAction as AircraftActions;
  switch (action.type) {
    case AircraftActionTypes.AddAircraft: {
      return adapter.addOne(action.payload.aircraft, state);
    }

    case AircraftActionTypes.UpsertAircraft: {
      return adapter.upsertOne(action.payload.aircraft, state);
    }

    case AircraftActionTypes.AddAircrafts: {
      return adapter.addMany(action.payload.aircrafts, state);
    }

    case AircraftActionTypes.UpsertAircrafts: {
      return adapter.upsertMany(action.payload.aircrafts, state);
    }

    case AircraftActionTypes.UpdateAircraft: {
      return adapter.updateOne(action.payload.aircraft, state);
    }

    case AircraftActionTypes.UpdateAircrafts: {
      return adapter.updateMany(action.payload.aircrafts, state);
    }

    case AircraftActionTypes.DeleteAircraft: {
      return adapter.removeOne(action.payload.id, state);
    }

    case AircraftActionTypes.DeleteAircrafts: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case AircraftActionTypes.LoadAircrafts: {
      return adapter.setAll(action.payload.aircrafts, state);
    }

    case AircraftActionTypes.ClearAircrafts: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
